












import { Vue, Component } from 'vue-property-decorator';
import VoteButton from './components/VoteButton.vue';
import * as config from './config';
import { getdetail } from './api';
import { appShare, wxShareInfo, autoOpenApp } from '@/common/ts/common';
@Component({
  name: 'DetailPage',
  components: {
    VoteButton,
  },
})
export default class DetailPage extends Vue {
  mustWeChat: boolean = true;
  option = config.OPTHINES;
  detailData = {votes: 0};
  voteWeChat = false;
  created() {
    getdetail(this.option.voteName, Number(this.$route.query.id))
    .then( (res: any) =>  this.detailData = res.data);
    this.$addPv(368);
    autoOpenApp();
    appShare({
      title: '2019用户最喜爱上游号评选',
      url: window.location.href,
      subtitle: '2019用户最喜爱上游号评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '2019用户最喜爱上游号评选',
      subtitle: '2019用户最喜爱上游号评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  votSuccess(res: any) {
    (this.detailData as any).votes =
      Number((this.detailData as any).votes) + 1;
  }
}
